import { useMemo } from "react";

import { useFeatureFlags } from "@smart/bridge-feature-flags-dom";
import { useLoadForms, useLoadSetting } from "@smart/manage-gql-client-dom";
import { useManageFormsContext, useUser } from "@smart/manage-hooks-dom";

import {
  countCustomReminderMessageForms,
  filterDisplayableForms,
} from "../../shared/custom-reminder-message";

export const useCustomReminderMessageFormCount = () => {
  const { "LINK-3736": automaticRemindersFlag } = useFeatureFlags();
  const { permission } = useUser();
  const { actingTeam } = useManageFormsContext();
  const skip = !automaticRemindersFlag;

  const setting = useLoadSetting({});
  const forms = useLoadForms(
    { teamUri: actingTeam?.uri, includeGlobal: true },
    { fetchPolicy: "cache-and-network", skip },
  );
  const loading = setting.loading || forms.loading;

  return useMemo(() => {
    if (skip || loading || !forms.result || setting.error) return undefined;

    return countCustomReminderMessageForms({
      forms: filterDisplayableForms({
        forms: forms.result,
        setting: setting.result,
        permission,
      }),
    });
  }, [skip, loading, forms.result, setting.result, setting.error, permission]);
};
